import { render } from "./KeyboardShortcuts.vue?vue&type=template&id=ca2521e4&ts=true"
import script from "./KeyboardShortcuts.vue?vue&type=script&lang=ts"
export * from "./KeyboardShortcuts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__